import { List } from 'immutable';
import { connect } from '../../../common/react-redux';
import BankEntriesList from './presenter';
import BankEntry from '../../../common/records/BankEntry';
export function mapStateToProps(state, props) {
  var bankEntries = List(props.recordIds).map(function (id) {
    return new BankEntry(state.getIn(['bankEntries', id]));
  });
  return {
    bankEntries: bankEntries
  };
}
export default connect(mapStateToProps)(BankEntriesList);